export default "__VITE_ASSET__C6MpJsGs__"